import React from "react";
import styled from "styled-components";

export default function ServiceBox({ image, title, subtitle }) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || ""; // Fallback to empty string if env variable is not set
  return (
    <Wrapper className="flex flexColumn">
      <ImageStyle src={`${backendUrl}${image}`} alt={title} />
      <TitleStyle className="font20 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  border-radius: 8px; /* Optional: adds slight rounding for a polished look */
  padding: 10px; /* Optional: adds some internal spacing */
  background-color: #f9f9f9; /* Light background color */
`;
const ImageStyle = styled.img`
  width:50px; /* Adjust size as needed */
  height: 50px; /* Adjust size as needed */
  object-fit: cover; /* Ensures image fits nicely */
  
  @media (max-width: 860px) {
    
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 40px 0;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;